import { atom } from 'jotai'

type Input = {
  targetProjectId: string | undefined
  targetApplicationId: number | undefined
  targetApplicationStepId: number | undefined
  isProxy: boolean | undefined
}

const state = atom<Input>({
  targetProjectId: undefined,
  targetApplicationId: undefined,
  targetApplicationStepId: undefined,
  isProxy: undefined,
})
export const applicationRequestStore = { state } as const
